<template>
  <button
    @click="$emit('sort', field)"
    :class="[
      'flex w-full items-center gap-1 hover:text-gray-700 focus:outline-none',
      align === 'center' ? 'justify-center text-center' : '',
      align === 'right' ? 'justify-end text-right' : '',
    ]"
  >
    <span
      :class="{
        'font-semibold text-gray-700': sortField === field,
      }"
    >
      {{ label }}
    </span>
    <svg
      class="w-3 h-3 transition-transform duration-150"
      :class="{
        'text-gray-700': sortField === field,
        'text-gray-400': sortField !== field,
        'rotate-180': sortField === field && sortDirection === 'asc',
      }"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 9l-7 7-7-7"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: "SortableHeader",
  props: {
    field: { type: String, required: true },
    label: { type: String, required: true },
    sortField: { type: String, default: null },
    sortDirection: { type: String, default: null },
    align: {
      type: String,
      default: "left",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
  },
  emits: ["sort"],
};
</script>
